import { motion } from "framer-motion";

/**
 * Faithful web replica of the Nom character drawn in the NomNom app
 * (frontend/src/buddy-face.tsx + buddy.tsx, "skin_classic": body #FFAA99, cheeks #FF7369, ink #2B2D42).
 */
export default function NomCharacter({ expression = "happy", className = "", bob = true, testId = "nom-character" }) {
  const joyful = expression === "joyful";
  return (
    <motion.svg
      viewBox="0 0 64 60"
      className={className}
      role="img"
      aria-label="Nom, the NomNom companion"
      data-testid={testId}
      animate={bob ? { y: [0, -3.5, 0] } : {}}
      transition={{ duration: 3.4, repeat: Infinity, ease: "easeInOut" }}
    >
      <rect x="1" y="1" width="62" height="58" rx="29" fill="#FFAA99" />
      {/* eyes with glints */}
      <rect x="15" y="20" width="9" height="13" rx="4.5" fill="#2B2D42" />
      <rect x="40" y="20" width="9" height="13" rx="4.5" fill="#2B2D42" />
      <rect x="18" y="22.5" width="3" height="3" rx="1.5" fill="#FFFFFF" />
      <rect x="43" y="22.5" width="3" height="3" rx="1.5" fill="#FFFFFF" />
      {/* cheeks */}
      <rect x="8" y="33" width="9" height="5" rx="2.5" fill="#FF7369" opacity="0.75" />
      <rect x="47" y="33" width="9" height="5" rx="2.5" fill="#FF7369" opacity="0.75" />
      {joyful ? (
        <g>
          <path d="M23 37 h18 v6 a9 6.5 0 0 1 -18 0 Z" fill="#2B2D42" />
          <path d="M25.5 43.5 h13 a6.5 4 0 0 1 -13 0 Z" fill="#FF7B93" />
        </g>
      ) : (
        <path d="M23 38.5 a9 7.5 0 0 0 18 0" fill="none" stroke="#2B2D42" strokeWidth="2.2" strokeLinecap="round" />
      )}
    </motion.svg>
  );
}
